export function clearAllCookies() {
  // Clearing all cookies. This function will extract all cookies from the browser cache,
  // then sets their value to empty string and sets the expires parameter to current UTC datetime.
  // Browser will delete the cookie as soon as expires parameter value is in the past.

  document.cookie.split(";").forEach((c) => {
    document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
  });
}